/**
 * API文档地址
 * http://yapi.kapeixi.cn/project/255/interface/api/cat_4020
 */

import {} from 'server/modules/4020'
